<template>
    <v-container fluid>
        <v-row justify="center" class="my-6">
            <v-col align="center" >
                <h1 class="text-h2 text-center font-weight-medium my-4">404</h1>
                <p v-if="ghlKey" class="text-h5">
                    {{ $t('components.NotFound.GHLCustomer') }}
                </p>
                <p v-else class="text-h5">
                    {{ $t('components.NotFound.Page') }}
                </p>
            </v-col>
        </v-row>

        <v-row align="center" justify="center" class="my-6">
            <v-col cols="auto" class="text-center">
                <v-img src="/select-location.png" min-width="200" max-width="300"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

/**
 * NotFound contains the 404 page when a customer is not found in GHL using ghl_key
 */
export default {
    name: 'NotFound',
    data: () => ({
        ghlKey: null
    }),
    async mounted() {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        const ghlKey = params.get("ghl_key");
        if (ghlKey) {
            this.ghlKey = ghlKey;
        }
    }
}
</script>